import React from "react";
import { styled } from "@mui/material/styles";
import { IconButton } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";

import ShopLogo from "./ShopLogo";
import useShopContext from "@hooks/useShopContext";

const PREFIX = "Navbar";

const classes = {
  iconButton: `${PREFIX}-iconButton`,
  centerContainer: `${PREFIX}-centerContainer`,
};

const Root = styled("div")(({ theme, progressBarOffSet }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(1, 3),
  width: "100%",
  marginTop: progressBarOffSet ? 10 : 0,
  [`& .${classes.iconButton}`]: {
    color: theme.palette.primary.contrastText,
    [theme.breakpoints.down("md")]: {
      width: "35px",
      height: "35px",
    },
  },

  [`& .${classes.centerContainer}`]: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const Navbar = ({ onBack, progressBarOffSet }) => {
  const { shop } = useShopContext();

  return (
    <Root progressBarOffSet={progressBarOffSet}>
      <IconButton color="inherit" className={classes.iconButton} onClick={onBack} size="large">
        <ArrowBack />
      </IconButton>
      <div className={classes.centerContainer}>
        {shop.display_logo && (shop?.logo || shop?.vendor?.company_photo) && <ShopLogo />}
      </div>
      <IconButton className={classes.iconButton} style={{ visibility: "hidden" }} size="large">
        <ArrowBack />
      </IconButton>
    </Root>
  );
};

export default Navbar;
